<!-- <div class="page-title-container container my-3">
    <h1 class="page-title">{{'my_account' | translate}}</h1>
    <!-- <button class="page-nav" (click)="toggleNavigation()">
        <mat-icon svgIcon="burger-n"></mat-icon>
    </button>  
</div>

<div class="block mt-4">
    <div class="container">
        <div class="row">
            <div class="nav-column col-12 col-lg-auto d-flex w-full">
                <div class="account-nav">
                    <!-- <h4 class="account-nav__title"><span class="text-sm"><span class="me-1">&#x2022; </span> </span>{{"navigation"|translate}}</h4>
                    <ul>
                        <li *ngFor="let link of links" class="account-nav__item" routerLinkActive="account-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
                            <a *ngIf="link.label =='logout'" class="cursor-pointer" (click)="logout()"><mat-icon class="link-icon" [svgIcon]="link.icon"></mat-icon>{{ link.label|translate }}</a>
                            <a *ngIf="link.label !='logout'" [routerLink]="link.url"><mat-icon class="link-icon" [svgIcon]="link.icon"></mat-icon>{{ link.label|translate }}</a>
                        </li>
                    </ul>

                    <h4 *ngIf="siteService.features?.quotations" class="account-nav__title"><span class="text-base"><span class="bulletm">&#x2022; </span> </span>{{"quotations"|translate}}</h4>
                    <ul *ngIf="siteService.features?.quotations">
                        <li *ngFor="let link of quotationsLinks" class="account-nav__item" routerLinkActive="account-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
                            <a *ngIf="link.label==='Draft Quotation' && quantity" [routerLink]="link.url"><mat-icon class="link-icon" [svgIcon]="link.icon"></mat-icon>{{ link.label|translate }}</a>
                            <a *ngIf="link.label!=='Draft Quotation'" [routerLink]="link.url"><mat-icon class="link-icon" [svgIcon]="link.icon"></mat-icon>{{ link.label|translate }}</a>
                        </li>
                    </ul>  
                    
                    <h4 *ngIf="siteService.features?.quotationRequests" class="account-nav__title"><span class="text-sm"><span class="bulletm">&#x2022; </span> </span>{{"quotation_requests"|translate}}</h4>
                    <ul *ngIf="siteService.features?.quotationRequests">
                        <li *ngFor="let link of quotationRequestsLinks" class="account-nav__item" routerLinkActive="account-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
                            <a [routerLink]="link.url"><mat-icon class="link-icon" [svgIcon]="link.icon"></mat-icon>{{ link.label|translate }}</a>
                        </li>
                    </ul>
                    <ng-container *ngIf="siteService.features?.propertyManagement">
                        <h4 class="account-nav__title"><span class="text-base"><span class="bulletm">&#x2022; </span> </span>{{"owner_property"|translate}}</h4>
                        <ul>
                            <li *ngFor="let link of ownerPropertyLinks" class="account-nav__item" routerLinkActive="account-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
                                <a [routerLink]="link.url">{{ link.label|translate }} </a>
                            </li>
                        </ul>

                        <h4 class="account-nav__title"><span class="text-base"><span class="bulletm">&#x2022; </span> </span>{{"property"|translate}}</h4>
                        <ul>
                            <li *ngFor="let link of propertyLinks" class="account-nav__item" routerLinkActive="account-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
                                <a [routerLink]="link.url">{{ link.label|translate }} </a>
                            </li>
                        </ul>
                        <h4 class="account-nav__title"><span class="text-base"><span class="bulletm">&#x2022; </span> </span>Tickets (Maintenance / Visits / etc)</h4>
                        <ul>
                            <li class="account-nav__item" routerLinkActive="account-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
                                <a>Tickets</a>
                            </li>
                        </ul>
                    </ng-container>


                </div>
            </div>
            <div class="col mt-4 mt-lg-0 px-1">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div> -->

@if (!showGeneralNavMenu) {
    <div class="container navigation-container">
        <div class="navigation-pills">
            @for (group of navigationItems; track group.label) {
            <div class="list-group">
                @if (group.label) {
                <div class="group-label">{{ group.label | translate }}</div>
                }
                @for (item of group.items; track item.routerLink) {
                <button class="link-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                    [routerLink]="item.routerLink?.toString()?.replaceAll('/account', '')" (click)="item.click ? item.click() : null">
                    @if (item.iconType == 'material') {
                    <mat-icon class="icon">{{item.icon}}</mat-icon>
                    } @else if (item.iconType == 'svg-icon') {
                    <mat-icon class="icon" [svgIcon]="item.icon"></mat-icon>
                    } @else if (item.iconType == 'fa') {
                    <mat-icon class="icon" fontSet="fa" [fontIcon]="item.icon"></mat-icon>
                    } @else {
                    <img class="icon" [src]="item.icon">
                    }
                    <div class="label">{{ item.label | translate }}</div>
                </button>
                }
            </div>
            }
        </div>
    </div>
}

<div class="container my-4 quote-module">
    <router-outlet></router-outlet>
</div>